import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormGroup, Input, Label, Row } from 'reactstrap';
export const Header = ({ title, ids, selectedRepos, onToggleItems }) => {
    return _jsx(Row, { children: _jsx(FormGroup, { check: true, className: 'flex-grow-1 mt-2', children: _jsxs(Label, { check: true, className: 'cursor--pointer w-100', children: [_jsx(Input, { type: 'checkbox', checked: ids.filter((id) => selectedRepos.includes(id)).length === ids.length, onChange: () => onToggleItems(ids), "data-testid": "checkbox" }), _jsx("strong", { children: title })] }) }) }, title);
};
